export const GRADIENT_DIRECTION = {
  NONE : 1,
  TOP_TO_BOTTOM: 2,
  BOTTOM_TO_TOP: 3
}